<div class="c-userActions">
  <!-- PARA HABILITAR A BUSCA DESCOMENTE AS LINHAS ABAIXO -->
  <form [formGroup]="form" class="c-userActions_form" novalidate>
    <mat-form-field class="c-userActions_search" floatLabel="never">
      <input
        class="c-userActions_input"
        formControlName="search"
        matInput
        placeholder="Buscar vinhos"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </form>

  <button
    class="c-userActions_searchBtn"
    type="button"
    title="Abrir busca mobile"
  >
    <svg class="c-userActions_searchBtn_icon c-icon">
      <use xlink:href="#ic-search" />
    </svg>
  </button>
  <!-- routerLink="/leilao/lotes-favoritos" *ngIf="initialsName" -->
  <button
    class="c-userActions_notifications"
    *ngIf="user$"
    type="button"
    title="Favoritos"
    (click)="goToLogin()"
  >
    <svg class="c-userActions_notifications_icon c-icon">
      <use xlink:href="#ic-heart" />
    </svg>
  </button>

  <div class="c-userActions_userArea">
    <a class="m-button" routerLink="/login" *ngIf="!user$">Entrar</a>

    <button
      class="c-userActions_userArea_btn"
      *ngIf="user$"
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      type="button"
      title="Menu do usuário"
    >
      <span
        class="c-userActions_userAreaLogado"
        *ngIf="initialsName; else elseAvatarTemplate"
      >
        {{ initialsName }}
      </span>
      <ng-template #elseAvatarTemplate>
        <svg class="c-userActions_userArea_icon c-icon--xs">
          <use xlink:href="#ic-userLoggedIn" />
        </svg>
      </ng-template>
    </button>
  </div>
</div>

<mat-menu
  class="c-header_menuUserMobile c-userActions_userArea--menuUser"
  xPosition="before"
  #userMenu="matMenu"
>
  <ul class="c-userActions_userArea_list">
    <li class="" *ngFor="let menu of menuList | keyvalue">
      <h2 class="c-userActions_userArea_list_title">{{ menu.key.slice(2) }}</h2>
      <ul class="c-userActions_userArea_list_item">
        <li *ngFor="let item of menu.value">
          <a class="c-userActions_userArea_list_link" (click)="onMenuClick(item)">
            <svg class="c-userActions_userArea_icon c-icon--xs">
              <use [attr.xlink:href]="item.icon" />
            </svg>
            <span class="c-userActions_userArea_list_text">{{
              item.text
            }}</span>
          </a>
        </li>
      </ul>
    </li>
    <li class="c-userActions_userArea_list_item s-paddingTop-sm">
      <button class="c-userActions_userArea_list_link" (click)="logout()">
        <svg class="c-userActions_userArea_icon c-icon--xs">
          <use xlink:href="#ic-logout" />
        </svg>
        <span class="c-userActions_userArea_list_text">Sair</span>
      </button>
    </li>
  </ul>
</mat-menu>
